import React from 'react'
import { useEffect } from 'react';
import { Col } from 'react-flexbox-grid'

export const PagarVisa = ({form, scriptEl}) => {

  useEffect(() => {
    document.getElementById("btn_pago").appendChild(form);
    document.getElementById("boton_pago").appendChild(scriptEl);
  }, [form, scriptEl])
  

  return (
    <Col className="border-left" xs={12} sm={3}>
      <div id="btn_pago"></div>
      <br></br>
      <img
        src="https://www.alejoscolor.com/wp-content/uploads/2020/05/formas-pago.png"
        alt="LogoVisa"
        width="100%"
      ></img>
    </Col>
  )
}
